module.exports = __webpack_public_path__ + "assets_app/img/play.b459c176.png";